import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@components/atoms/Typography';
import { RoundIcon, RoundIconVariants } from '@components/atoms/RoundIcon';
import styles from './PriceBox.module.css';

export interface PriceBoxProps {
    price: number;
    currency?: string;
    period?: string;
    isLiked?: boolean;
    onLikeClick?: () => void;
}

const Separator: FC = () => <hr style={{ borderTop: '1px solid #e9e9e9', margin: '15px 0' }} />;

export const PriceBox: FC<PriceBoxProps> = ({ price, currency = '€', period, isLiked = false, onLikeClick }) => {
    const { t } = useTranslation();

    const translations = {
        priceLabel: t('price-box-component.price-label'),
        period: period || t('price-box-component.period'),
        favoriteText: t('price-box-component.favorite-text'),
    };

    return (
        <div className={styles.container}>
            {/* Price section */}
            <div className={styles.priceSection}>
                <Typography fontSize="24" fontWeight="900" color="primary" classes={styles.priceText}>
                    {translations.priceLabel} {price.toLocaleString('pt-PT')}
                    {currency}
                    <span className={styles.period}> /{translations.period}</span>
                </Typography>
            </div>

            <Separator />

            {/* Favorites and social icons */}
            <div className={styles.actionsSection}>
                <div className={styles.favoriteSection} onClick={onLikeClick} style={{ cursor: 'pointer' }}>
                    <RoundIcon
                        icon={isLiked ? "fa-solid fa-heart" : "fa-light fa-heart"}
                        variant={RoundIconVariants.variant3}
                    />
                    <span className={styles.favoriteText}>{translations.favoriteText}</span>
                </div>
                <div className={styles.socialIcons}>
                    <span className={styles.socialIcon}>
                        <i className="fa-brands fa-facebook-f" />
                    </span>
                    <span className={styles.socialIcon}>
                        <i className="fa-brands fa-instagram" />
                    </span>
                </div>
            </div>
        </div>
    );
};